export const LISTING_KEY = 'LISTINGS_BOT_SAVED_LISTINGS'
export const JWT_TOKEN_KEY = 'LISTINGS_BOT_JWT_TOKEN'
// Same as JWT_TOKEN_KEY. JWT_TOKEN_KEY will be deprecated soon
export const ACCESS_TOKEN = 'LISTINGS_BOT_ACCESS_TOKEN'
export const EXTENSION_DEBOUNCE_KEY_MAP =
  'LISTINGS_BOT_EXTENSION_DEBOUNCE_KEY_MAP'
